import styled from '@emotion/styled';
import MuiMenuItem from '@material-ui/core/MenuItem';
import MuiDivider from '@material-ui/core/Divider';
import COLORS from '$variables/colors';
import { spacing } from '$variables/theme';

export const MenuContent = styled.div`
  min-width: 160px;
  margin-top: ${spacing.xSmall};
  box-shadow: 0 0 8px 0 ${COLORS.shadow3};
  background: ${COLORS.white};
  border-radius: 4px;
`;

export const MenuItem = styled(MuiMenuItem)`
  height: ${spacing.xxLarge};
  min-height: unset;
  padding: ${spacing.xxSmall} ${spacing.medium};
  color: ${COLORS.black};
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;

  svg {
    margin-right: ${spacing.small};
  }
`;

export const MenuDivider = styled(MuiDivider)`
  margin-top: ${spacing.xSmall};
  margin-bottom: ${spacing.xSmall};
`;

export const ModalContent = styled.div`
  padding: 0 ${spacing.small} ${spacing.small};
  text-align: center;
`;
